/** First non-empty validation message (stable key order when keys provided). */
export const getFirstValidationErrorMessage = (errors, orderedKeys) => {
    const keys = orderedKeys && orderedKeys.length > 0
        ? orderedKeys
        : Object.keys(errors);
    for (const key of keys) {
        const message = errors[key]?.trim();
        if (message) {
            return message;
        }
    }
    return null;
};
